module.exports = __webpack_public_path__ + "img/exam_online_bg.1e716f1a.png";